<template>
  <div id="page-user-view">
    <Charger
      :isPromptActive="addNewPrompt"
      @closePrompt="toggleDataPrompt"
      :charger="charger"
      :refreshContent="general"
    />
    <close
      :isPromptActive="promptClose"
      :closeCallBack="closeCallBack"
      :problem="choosen_problem"
      @closePrompt="toggleClosePrompt"
    />

    <vs-button
      class="mb-2 shadow-lg"
      type="border"
      @click="$router.go(-1)"
      size="small"
      >Retour
    </vs-button>

    <div class="vx-row">
      <div class="vx-col lg:w-3/3 w-full">
        <vx-card
          title="Détails du problème"
          refresh-content-action
          @refresh="closeCardAnimation"
        >
          <div slot="no-body" class="p-6">
            <div class="tabs-container">
              <vs-tabs
                v-model="activeTab"
                class="tab-action-btn-fill-conatiner"
              >
                <vs-tab
                  label="Informations"
                  icon-pack="feather"
                  icon="icon-info"
                >
                  <div class="tab-text" v-if="information.customer">
                    <div class="vx-row mb-4">
                      <div class="vx-col" id="avatar-col">
                        <div class="img-container mb-4">
                          <!-- ||||||||||-- {{information.customer.logo}} --|||||||||| -->
                          <img
                            style="max-width: 180px; max-height: 180px"
                            v-if="information.customer.logo"
                            :src="information.customer.logo"
                            class="rounded w-full shadow-drop"
                          />
                          <!-- :src="information.customer.logo" -->

                          <img
                            v-if="!information.customer.logo"
                            src="@/assets/images/ccmt_mtn_logo.jpeg"
                            class="rounded w-full shadow-drop"
                          />
                        </div>
                      </div>

                      <div class="vx-col flex-1">
                        <div class="flex mb-3">
                          <div class="flex-1">
                            <span>Client</span>
                            <h5
                              class="text-primary cursor-pointer"
                              @click="clientActive = true"
                            >
                              {{ information.customer.social_reason }}
                            </h5>
                            <vs-popup
                              class="holamundo"
                              title="Détails du client"
                              :active.sync="clientActive"
                            >
                              <div class="vx-row">
                                <div class="vx-col">
                                  <img
                                    src="@/assets/images/eba-client-2.png"
                                    class="rounded w-full shadow-drop"
                                  />
                                </div>
                                <div class="vx-col flex-1">
                                  <div class="mb-2">
                                    <span>Raison sociale</span>
                                    <h5>
                                      {{ information.customer.social_reason }}
                                    </h5>
                                  </div>
                                  <div class="flex justify-between mb-2">
                                    <div>
                                      <span>Catégorie</span>
                                      <h5>
                                        {{ information.customer.segment }}
                                      </h5>
                                    </div>
                                    <div>
                                      <span>Secteur d'activité</span>
                                      <h5>
                                        {{ information.customer.activity_area }}
                                      </h5>
                                    </div>
                                    <div>
                                      <span>Régime de taxation</span>
                                      <h5>{{ information.customer.tax }}</h5>
                                    </div>
                                  </div>
                                  <div class="mb-2">
                                    <span>Email</span>
                                    <h5>
                                      <a :href="information.customer.email">{{
                                        information.customer.email
                                      }}</a>
                                    </h5>
                                  </div>
                                  <div class="flex mb-2">
                                    <div class="mr-4">
                                      <span>Téléphone</span>
                                      <h5>{{ information.customer.phone }}</h5>
                                    </div>
                                    <div>
                                      <span>Fax</span>
                                      <h5>{{ information.customer.fax }}</h5>
                                    </div>
                                  </div>
                                  <div class="mb-2">
                                    <span class="font-semibold">Adresse</span>
                                    <p>{{ information.customer.address }}</p>
                                  </div>
                                </div>
                              </div>
                            </vs-popup>
                          </div>

                          <div class="flex-1">
                            <span>Nbr. incidents</span>
                            <h5 class="">
                              {{ information.nbr_incidents }}
                            </h5>
                          </div>
                          
                          <div class="flex-1">
                            <span>Traitée par</span>
                            <h5 class="">
                              {{ information.treat_by ? information.treat_by : "" }}
                            </h5>
                          </div>
                        </div>
                        <div class="mb-3">
                          <span>Service</span>
                          <h5>
                            {{ information.departement }} -
                            {{ information.service }}
                          </h5>
                        </div>
                        <div class="flex items-center mb-3">
                          <vs-chip color="primary">
                            <vs-avatar icon="cached" />
                            {{ information.status }}
                          </vs-chip>
                          <span
                            >Créé le
                            {{ convert_date(information.created_at) }}</span
                          >
                        </div>
                      </div>
                    </div>
                    <div class="vx-row">
                      <div class="vx-col w-full">
                        <vs-divider />
                        <h4 class="mb-3">{{ information.title }}</h4>
                        <div v-if="information.status_index == '1'">
                          <h5 class="mt-4">
                            Description de la cause du problème
                          </h5>
                          <p v-html="information.rca"></p>
                        </div>
                        <div v-if="information.status_index == '1'">
                          <h5 class="mb-3 mt-6">
                            Description des mesures de résolution
                          </h5>
                          <p v-html="information.solution"></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </vs-tab>
                <vs-tab
                  @click="getProblemIncidents()"
                  label="Incidents"
                  icon-pack="feather"
                  icon="icon-clock"
                >
                  <incidents :incidents="incidents" />
                </vs-tab>
                <vs-tab
                  @click="getComments()"
                  label="Commentaires"
                  icon-pack="feather"
                  icon="icon-message-square"
                >
                  <VuePerfectScrollbar class="scroll-area" :settings="settings">
                    <comments :comments="comments" />
                  </VuePerfectScrollbar>
                </vs-tab>
              </vs-tabs>
            </div>
            <!-- <vs-divider /> -->

            <div class="flex flex-wrap justify-end pb-3">
              <vs-button
                class="mt-4 mr-2 shadow-lg"
                type="border"
                v-if="
                  $store.state.is_dispatcher()
                "
                @click="assignShow()"
                >Assigner la requête
              </vs-button>
              <vs-button
                class="mt-4 mr-2 shadow-lg"
                type="border"
                v-if="information.closed_at == null"
                @click="(promptClose = true), (choosen_problem = information)"
                >Clôturer
              </vs-button>
              <vs-button
                class="mt-4 mr-2 shadow-lg"
                color="#0d6efd"
                @click="
                  (show_comment_zone = !show_comment_zone),
                    (files = []),
                    (file_names = []),
                    (comment.message = '')
                "
                >Commenter
              </vs-button>
            </div>
            <div v-if="show_comment_zone == true" class="comment_zone">
              <vs-textarea
                rows="4"
                v-model="comment.message"
                placeholder="Votre commentaire"
                class="mr-3 w-full"
                name="item-name"
              >
              </vs-textarea>
              <vs-button
                @click="$refs.updateCommentImgInput.click()"
                type="filled"
                size="small"
                >Ajouter un fichier</vs-button
              >
              <input
                type="file"
                class="hidden"
                ref="updateCommentImgInput"
                @change="incCommentFile"
              />
              <vs-row>
                <div v-for="(img, index) in files" :key="index">
                  <div class="modify-img flex justify-between mt-5">
                    <div class="mail__attachment">
                      <vs-chip color="grey" class="ml-2 mr-3 cursor-pointer">
                        <vs-avatar icon="cloud_download" />
                        {{ file_names[index] }}
                      </vs-chip>
                    </div>
                    <vs-button
                      @click="devCommentFile(file_names[index])"
                      type="border"
                      color="danger"
                      size="small"
                      >Supprimer</vs-button
                    >
                  </div>
                </div>
              </vs-row>
              <vs-button
                size="small"
                :disabled="files.length == 0 && comment.message == ''"
                class="mt-4 mr-2 shadow-lg"
                type="border"
                @click="sendComment()"
                >Envoyer
              </vs-button>
              <vs-button
                size="small"
                class="mt-4 ml-1 shadow-lg"
                type="filled"
                @click="
                  (show_comment_zone = false),
                    (files = []),
                    (file_names = []),
                    (comment.message = '')
                "
                >Annuler
              </vs-button>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Comments from "./components/comments.vue";
import moment from "moment";
import Charger from "./charger.vue"
import Incidents from "./components/incidents.vue";
import { _buildQuery } from "../../helpers/helper";
import Close from "./components/close.vue";

var base_self;

export default {
  components: {
    VuePerfectScrollbar,
    Comments,
    Incidents,
    Close,
    Charger
  },
  watch: {
    "$route.params.id": function () {
      base_self.general();
    },
  },
  data() {
    return {
      information: {},
      addNewPrompt: false,
      charger: [],
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      show_comment_zone: false,
      files: [],
      file_names: [],
      comment: {
        message: "",
      },
      comments: [],
      activeTab: 0,
      clientActive: false,
      contractActive: false,
      incidents: [],
      choosen_problem: {
        customer_id: "",
        title: "",
        departement_id: "",
        service_id: "",
        incident_list: [],
      },
      promptClose: false,
    };
  },
  methods: {
    toggleClosePrompt(val = false) {
      this.promptClose = val;
    },
    closeCallBack() {
      this.getProblemDetails();
    },
    async getRequests_detail_information(id) {
      let response = await base_self.$store.state.requests_detail_information(
        {},
        id
      );

      base_self.information = response.data;
      // console.log(' ------base_self.information: ------------ ', base_self.information);
    },
    async getRequests_detail_history(id) {
      let response = await base_self.$store.state.requests_detail_history(
        {},
        id
      );

      var length = response.data.length;
      var array = [];

      for (let iuoy = 0; iuoy < length; iuoy++) {
        var item = response.data[iuoy];

        array.push({
          color: "success",
          icon: "CheckIcon",
          title: item.title,
          desc: item.content,
          time: item.created_at,
        });
      }

      base_self.history = array;
    },
    async getRequests_detail_tasks(id) {
      let response = await base_self.$store.state.requests_detail_tasks({}, id);

      base_self.tasks = response.data;
    },
    async getRequests_detail_comments(id) {
      let response = await base_self.$store.state.requests_detail_comments({
        model_type: "1",
        model_id: id,
      });

      base_self.comments = response.data;
    },
    async getRequests_detail_approbation(id) {
      let response = await base_self.$store.state.requests_detail_approbation(
        {},
        id
      );
      base_self.approvalDatas = response.data;
      if (response.data.length > 0) base_self.test = true;
    },
    // general() {
    //   base_self.getRequests_detail_approbation(base_self.$route.params.id);
    //   base_self.getRequests_detail_information(base_self.$route.params.id);
    //   base_self.getRequests_detail_history(base_self.$route.params.id);
    //   base_self.getRequests_detail_tasks(base_self.$route.params.id);
    //   base_self.getRequests_detail_comments(base_self.$route.params.id);
    // },
    toggleDataPrompt(val = false) {
      this.addNewPrompt = val;
    },
    getCharger() {
      this.$vs.loading();
      this.$http
        .get("/users?profile=3&paginate=0")
        .then((response) => {
          this.charger = response.data;
          this.$vs.loading.close();
        })
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close();
        });
    },
    assign() {},
    assignShow() {
      this.getCharger();
      this.addNewPrompt = true;
    },
    incCommentFile(input) {
      if (input.target.files && input.target.files[0]) {
        var reader = new FileReader();
        var base_self = this;
        reader.onload = () => {
          base_self.file_names.push(input.srcElement.files[0].name);
          base_self.files.push(base_self.$refs.updateCommentImgInput.files[0]);
        };
        reader.readAsDataURL(input.target.files[0]);
      }
    },
    devCommentFile(img_name) {
      this.file_names.forEach((item, index) => {
        var fileName = this.file_names[index];
        if (img_name === fileName) {
          this.file_names.splice(index, 1);
          this.files.splice(index, 1);
        }
      });
    },
    sendComment() {
      this.$vs.loading();
      let formdata = new FormData();
      formdata.append("model_id", this.$route.params.id);
      formdata.append(
        "comment",
        this.comment.message ? this.comment.message : null
      );
      formdata.append("model_type", "2");
      this.files.forEach((item, index) => {
        formdata.append("files[" + index + "]", item);
      });
      this.$http
        .post("/comments/store", formdata)
        .then((response) => {
          if (response.data.status == true) {
            window.GETCCMT.success(
              "Commentaire enregistré avec succès",
              response
            );
            this.comment.message = "";
            this.files = [];
            this.file_names = [];
          }
          this.$vs.loading.close();
          this.getComments();
        })
        .catch((error) => {
          console.log(error);
          window.GETCCMT.error({
            message: "Echec envoi commentaire a échoué.",
          });
          this.$vs.loading.close();
        });
    },
    convert_date(ddate) {
      return moment(ddate, "YYYY-MM-DD HH:mm:ss").format(
        "DD/MM/YYYY à HH:mm:ss"
      );
    },
    async getProblemDetails() {
      try {
        this.$vs.loading();
        let response = await this.$http.get(
          "/problems/details/" + this.$route.params.id
        );
        this.information = response.data;
        this.$vs.loading.close();
      } catch (error) {
        console.log(error);
        this.$vs.loading.close();
        if (error.response.status === 401) {
          this.$router.push({ name: "login" });
        }
        console.log(error);
      }
    },
    async getProblemIncidents() {
      try {
        this.$vs.loading();
        let response = await this.$http.get(
          "/problems/incidents-list/" + this.$route.params.id
        );
        this.incidents = response.data;
        this.$vs.loading.close();
      } catch (error) {
        console.log(error);
        this.$vs.loading.close();
        if (error.response.status === 401) {
          this.$router.push({ name: "login" });
        }
        console.log(error);
      }
    },
    async getComments() {
      try {
        this.$vs.loading();
        let params = {
          model_type: "2",
          model_id: this.$route.params.id,
        };
        let response = await this.$http.get("/comments" + _buildQuery(params));
        this.comments = response.data;
        this.$vs.loading.close();
      } catch (error) {
        console.log(error);
        this.$vs.loading.close();
        if (error.response.status === 401) {
          this.$router.push({ name: "login" });
        }
        console.log(error);
      }
    },
    closeCardAnimation(card) {
      this.general();
      card.removeRefreshAnimation(2000);
    },
    general() {
      this.getProblemDetails();
      this.getProblemIncidents();
      this.getComments();
    },
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
  },
  mounted() {
    this.getProblemDetails();
  },
};
</script>

<style lang="scss">
.chat-card-log {
  height: 400px;
}
.comment_zone {
  border: 1px solid black;
  border-radius: 5px;
  padding: 10px;
  background: #f8f8f8;
}
.vs-textarea {
  background: #ffffff !important;
}

.scroll-area {
  position: relative;
  margin: auto;
  // width: 400px;
  height: 300px;
}
</style>
